(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {

  /*
   * Hide facets if no products found
   */
  function checkAndHideFacets() {

    const productCards = document.querySelectorAll(
      '.hershey-product-card'
    );

    const facetsWrappers = document.querySelectorAll(
      '.facets-block-wrapper, .facets-block-wrapper--vertical'
    );

    if (productCards.length === 0) {

      facetsWrappers.forEach(function (wrapper) {
        wrapper.classList.add('hide-facets');
      });

    } else {

      facetsWrappers.forEach(function (wrapper) {
        wrapper.classList.remove('hide-facets');
      });

    }
  }


  /*
   * Initial check
   */
  checkAndHideFacets();


  /*
   * Watch dynamic collection updates
   */
  const observer = new MutationObserver(function () {
    checkAndHideFacets();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


  /*
   * ADD TO CART
   */
  document.addEventListener('click', async function (event) {

    const button = event.target.closest(
      '.hershey-add-to-cart'
    );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();


    /*
     * Prevent double click
     */
    if (button.disabled) return;


    /*
     * Get variant
     */
    const variantId = button.getAttribute(
      'data-variant-id'
    );


    if (!variantId) {

      console.error(
        'Add to Cart Error: Variant ID is missing.'
      );

      return;
    }


    /*
     * Save original button text
     */
    const originalText = button.textContent;


    /*
     * Loading state
     */
    button.textContent = 'Adding...';
    button.classList.add('adding');
    button.disabled = true;


    try {

      /*
       * Shopify Ajax Add To Cart
       */
      const response = await fetch(
        '/cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        }
      );


      /*
       * Read Shopify response
       */
      const data = await response.json();


      /*
       * Check Shopify error
       */
      if (!response.ok) {

        throw new Error(
          data && data.description
            ? data.description
            : 'Unable to add product to cart.'
        );

      }


      /*
       * PRODUCT SUCCESSFULLY ADDED
       *
       * Directly go to cart.
       *
       * Using current storefront origin prevents
       * incorrect domain/path redirects.
       */
      window.location.assign(
        window.location.origin + '/cart'
      );

    } catch (error) {

      console.error(
        'Add to Cart Error:',
        error
      );


      /*
       * Error state
       */
      button.textContent = 'Error - Try Again';
      button.classList.remove('adding');
      button.disabled = false;


      /*
       * Restore button
       */
      setTimeout(function () {

        button.textContent = originalText;

      }, 2000);

    }

  });

});
  } catch(e) { console.error(e); }
})();

})();
